import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

import { getTeamDetails } from '../../../actions/teamActions';

import GenericButton from '../../common/GenericButton';
import GenericSearch from '../../common/GenericSearch';
import UserListItems from './UserListItems';

class Users extends Component {
  static propTypes = {
    users: PropTypes.instanceOf(Array),
    teams: PropTypes.instanceOf(Array),
    activeUsers: PropTypes.instanceOf(Array),
    activeTeams: PropTypes.instanceOf(Array),
    updateSelectedItems: PropTypes.func,
    clearItems: PropTypes.bool,
  }

  static defaultProps = {
    users: [],
    activeUsers: [],
    clearItems: false,
  }

  state = {
    items: [],
    itemsLeft: [],
    selectedItemsLeft: [],
    itemsRight: [],
    selectedItemsRight: [],
    rightSelectionCount: 0,
    originalBaseLists: [],
  };


  UNSAFE_componentWillMount() {
    this.updateInitialState();
  }

  UNSAFE_componentWillReceiveProps({ clearItems, activeUsers, users }) {
    if (clearItems !== this.props.clearItems) {
      this.removeAll();
    }
    if (!_.isEqual(users, this.props.users)) {
      this.setState({ users }, () => {
        this.updateInitialState();
      });
    }
      if ( !_.isEqual(activeUsers, this.state.itemsRight,  )) {
      this.setState({
        items: [],
        itemsLeft: [],
        selectedItemsLeft: [],
        itemsRight: [],
        selectedItemsRight: [],
        rightSelectionCount: 0,
        originalBaseLists: [],
      }, () => {
        this.updateInitialState();
      });
    }
  }

  updateInitialState = () => {
    const users = this.renderUserData();
    const selectedItemsLeft = [];
    users.map((user, i) => {
      if (user.isActive) {
        selectedItemsLeft.push(i);
      }
      return null;
    });
    this.setState({
      items: users,
      itemsLeft: users,
      selectedItemsLeft,
      originalBaseLists: users,
    }, () => {
      if (selectedItemsLeft.length > 0) {
        this.addSelected();
      }
    });
  }

  handleSearch = searchResult => this.setState({ itemsLeft: searchResult });

  handleLeftPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsLeft;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsLeft;
      let lastItem = this.state.selectedItemsLeft.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsLeft.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsLeft: selectedItems,
      });
    }
  };

  addSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsLeft.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsRight.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: itemsRemaining,
      itemsRight: selections,
      rightSelectionCount: selections.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  removeSelected = () => {
    const selections = [];
    const itemsRemaining = [];
    this.state.itemsRight.map(item => {
      if (item.selected) {
        selections.push(item);
      } else {
        itemsRemaining.push(item);
      }
      return item;
    });

    this.state.itemsLeft.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      itemsLeft: selections,
      itemsRight: itemsRemaining,
      rightSelectionCount: itemsRemaining.length,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  handleMoveAllLeft = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToLeft = itemsRight;
    _.map(itemsLeft, item => {
      allItemsToLeft.push(item);
    });
    this.setState({
      itemsLeft: allItemsToLeft,
      itemsRight: [],
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems([]);
    });
  }

  handleMoveAllRight = () => {
    const { itemsLeft, itemsRight } = this.state;
    const allItemsToRight = itemsLeft;
    _.map(itemsRight, item => {
      allItemsToRight.push(item);
    });
    this.setState({
      itemsRight: allItemsToRight,
      itemsLeft: [],
      selectedItemsLeft: [],
      selectedItemsRight: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  }

  removeAll = () => {
    const leftPanelItems = [];
    leftPanelItems.push(...this.state.itemsLeft, ...this.state.itemsRight);
    this.setState({
      itemsRight: [],
      itemsLeft: leftPanelItems,
      rightSelectionCount: 0,
      selectedItemsRight: [],
      selectedItemsLeft: [],
    }, () => {
      this.props.updateSelectedItems(this.state.itemsRight);
    });
  };

  handleRightPanelClick = (id, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = this.state.selectedItemsRight;
      }
      selectedItems.push(parseInt(id, 10));
      this.setState({
        selectedItemsRight: selectedItems,
      });
    } else {
      selectedItems = this.state.selectedItemsRight;
      let lastItem = this.state.selectedItemsRight.pop();
      let currentItemId = id;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      this.state.itemsRight.map(item => {
        if (item.id >= lastItem && item.id <= parseInt(currentItemId, 10)) {
          selectedItems.push(item.id);
        }
        return item;
      });
      this.setState({
        selectedItemsRight: selectedItems,
      });
    }
  };

  handleExpendTree = (e, id, teamid, hasChild, position) => {
    e.stopPropagation();
    let positionItem = _.cloneDeep(this.state.itemsLeft);
    if (position === 'right') {
      positionItem = _.cloneDeep(this.state.itemsRight);
    }
    // let updateChildrenInItem = itemsLeft;
    if (hasChild) {
      const items = _.map(positionItem, item => {
        if (item.type === 'TEAM') {
          let children = item.children;
          if (item.id === id) {
            children = [];
          }
          const data = {
            ...item,
            children,
          };
          return data;
        }
        return item;
      });
      if (position === 'right') {
        this.setState({ itemsRight: items, disableButtons: false });
      } else {
        this.setState({ itemsLeft: items, disableButtons: false });
      }
    } else {
      this.setState({ disableButtons: true }, () => {
        getTeamDetails(teamid)
        .then(response => {
          const items = _.map(positionItem, item => {
            if (item.type === 'TEAM') {
              let children = item.children;
              if (response && item.id === id) {
                children = response.users;
              }
              const data = {
                ...item,
                children,
              };
              return data;
            }
            return item;
          });
          if (position === 'right') {
            this.setState({ itemsRight: items, disableButtons: false });
          } else {
            this.setState({ itemsLeft: items, disableButtons: false });
          }
        });
      });
    }
  }

  renderUserData = () => {
    const users = this.props.users;
    const teams = this.props.teams;
    const activeUsers = this.props.activeUsers;
    const activeTeams = this.props.activeTeams;
    const combinedItems = [];
    const combinedActiveItems = [];

    if (!_.isEmpty(teams)) {
      teams.map(team => {
        const items = {
          ...team,
          type: 'TEAM',
          itemId: team.id,
          itemText: team.name,
        };
        combinedItems.push(items);
        return false;
      });
    }
    users.map(user => {
      const items = {
        ...user,
        type: 'USER',
        itemId: user.userId,
        itemText: user.emailLogin,
      };
      combinedItems.push(items);
      return false;
    });
    if (!_.isEmpty(activeTeams)) {
      activeTeams.map(team => {
        const items = {
          ...team,
          type: 'TEAM',
          itemId: team.id,
          itemText: team.name,
        };
        combinedActiveItems.push(items);
        return false;
      });
    }
    activeUsers.map(user => {
      const items = {
        ...user,
        type: 'USER',
        itemId: user.userId,
        itemText: user.emailLogin,
      };
      combinedActiveItems.push(items);
      return false;
    });

    const items = combinedItems.map((ci, i) => {
      const activeUser = _.filter(combinedActiveItems, item => item.itemId === ci.itemId && item.itemText === ci.itemText);
      const selected = activeUser.length > 0;
      const items = {
        ...ci,
        selected: false,
        id: i,
        isActive: selected,
      };
      if (ci.type === 'USER') {
        items.emailLogin = ci.emailLogin;
        items.text = `${ci.firstName} ${ci.lastName}`;
      }
      if (ci.type === 'TEAM') {
        items.text = ci.name;
        items.children = [];
      }
      return items;
    });
    return items;
  }

  renderSearchItems = () => {
    const { items, itemsRight } = this.state;
    const filteredItems = [];
    _.map(items, item => {
      const hasItem = _.filter(itemsRight, k => k.itemId === item.itemId);
      if (_.isEmpty(hasItem)) {
        filteredItems.push(item);
      }
    });
    return filteredItems;
  }

  render() {
    return (
      <div className="multi-select-search-component">
        <div className="trend-search-component">
          <div className="add-user-form--row">
            <div className="add-user-form--col">
              <GenericSearch
                searchItems={this.renderSearchItems()}
                searchField="text"
                handleSearchResult={this.handleSearch}
                placeholder="Search User..."
              />
            </div>
          </div>
        </div>
        <div className="add-user-form--row">
          <div className="add-user-form--col">
            <div className="base-left-label">Available User(s)</div>
            <UserListItems
              items={this.state.itemsLeft}
              selectedItems={this.state.selectedItemsLeft}
              handleSelection={this.handleLeftPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="left"
            />
          </div>
          <div className="add-user-form--col-center add-user-form--col">
            <div className="stacked button-group multi-select-button-group">
              <GenericButton
                name=" "
                btnStyle="button btn-add btn-priaryDisable"
                onBtnClick={this.addSelected}
                {...(this.state.selectedItemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-add-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllRight}
                {...(this.state.itemsLeft.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove btn-cncl"
                onBtnClick={this.removeSelected}
                {...(this.state.selectedItemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />

              <GenericButton
                name=" "
                btnStyle="button btn-remove-all btn-priaryDisable"
                onBtnClick={this.handleMoveAllLeft}
                {...(this.state.itemsRight.length < 1
                  ? { btnDisabled: true }
                  : {})}
              />
            </div>
          </div>
          <div className="add-user-form--col">
            <div className="base-left-label">Selected User(s)</div>
            <UserListItems
              items={this.state.itemsRight}
              selectedItems={this.state.selectedItemsRight}
              handleSelection={this.handleRightPanelClick}
              handleExpendTree={this.handleExpendTree}
              position="right"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Users;
